export function initMosaic($) {
  const $tiles = $('.wb-tile');
  if (!$tiles.length) {
    return;
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reducedMotion) {
    $tiles.on('mouseenter focusin', function () {
      $(this).addClass('is-hovered');
    });

    $tiles.on('mouseleave focusout', function () {
      $(this).removeClass('is-hovered');
    });
  }

  const $rotatingTiles = $('[data-wb-rotating-tile]');
  if (!$rotatingTiles.length || reducedMotion) {
    return;
  }

  $rotatingTiles.each(function () {
    const $tile = $(this);
    const $layers = $tile.find('[data-wb-rotate-item]');
    if ($layers.length < 2) {
      return;
    }

    const parsedInterval = Number.parseInt($tile.attr('data-rotation-interval') || '', 10);
    const intervalMs = Number.isFinite(parsedInterval) && parsedInterval >= 2000 ? parsedInterval : 5000;
    let activeIndex = 0;

    window.setInterval(() => {
      const nextIndex = (activeIndex + 1) % $layers.length;
      $layers.eq(activeIndex).removeClass('is-active');
      $layers.eq(nextIndex).addClass('is-active');
      activeIndex = nextIndex;
    }, intervalMs);
  });
}
